module.exports = __webpack_public_path__ + "img/logo.73e0f337.png";